import ColorfulSwitch from './colorful-switch';
export default ColorfulSwitch;
